import {fetchBody, URL_CUSTOMERPOSITION_GET_LIST, URL_CUSTOMERPOSITION_ADD, URL_CUSTOMERPOSITION_GET_DETAIL, URL_POSITIONDEMAND_GET_LIST, URL_POSITIONDEMAND_GET_DETAIL, URL_RECUITMENTCONTRACTORINSURANCE_ADD, URL_RECUITMENTCONTRACTORINSURANCE_GET, URL_RECUITMENTCONTRACTORINSURANCE_GET_LIST, URL_RECUITMENTCONTRACTORINSURANCE_SET_LIST} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_setRecruitmentContractorInsurance ({mReqInsurance, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqInsurance, token}), 
      url: URL_RECUITMENTCONTRACTORINSURANCE_ADD, 
      success,
      failure
    })
  }
}

export function api_setRecruitmentContractorInsuranceList ({mReqInsuranceList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqInsuranceList, token}), 
      url: URL_RECUITMENTCONTRACTORINSURANCE_SET_LIST, 
      success,
      failure
    })
  }
}

export function api_getRecruitmentContractorInsurance ({mReqInsurance, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqInsurance, token}), 
      url: URL_RECUITMENTCONTRACTORINSURANCE_GET, 
      success,
      failure
    })
  }
}

export function api_getRecruitmentContractorInsuranceList ({mReqInsuranceList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqInsuranceList, token}), 
      url: URL_RECUITMENTCONTRACTORINSURANCE_GET_LIST, 
      success,
      failure
    })
  }
}